import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scrolls to the element matching location.hash whenever the location changes.
 *  Handles cross-route hash links like `/#how-it-works` from /pricing → /. */
export default function ScrollToHash() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    const id = hash.slice(1);
    // Wait a tick so the target route has mounted before we look up the element.
    const attempt = (tries) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (tries > 0) {
        setTimeout(() => attempt(tries - 1), 60);
      }
    };
    attempt(10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, hash, key]);

  return null;
}
